import * as React from 'react';
import * as ReactDOM from 'react-dom';
import LandlordsRootComponent from './landlords-root-component';


ReactDOM.render(
    <LandlordsRootComponent />
, document.getElementById('root'));


if (module["hot"]) {
    module["hot"].accept()
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/landlords/index.tsx